import { create } from 'zustand';

/**
 * Workspace Access Store
 *
 * Manages workspace access status (blocked/unblocked)
 * Used to control module access when subscription is expired
 */
interface WorkspaceAccessState {
  isAccessBlocked: boolean;
  blockedAt: string | null;
  workspaceName: string | null;

  // Actions
  setAccessStatus: (isBlocked: boolean, blockedAt: string | null, workspaceName?: string) => void;
  clearAccessStatus: () => void;
}

export const useWorkspaceAccessStore = create<WorkspaceAccessState>((set) => ({
  isAccessBlocked: false,
  blockedAt: null,
  workspaceName: null,

  setAccessStatus: (isBlocked, blockedAt, workspaceName) =>
    set({
      isAccessBlocked: isBlocked,
      blockedAt,
      workspaceName: workspaceName ?? null,
    }),

  clearAccessStatus: () =>
    set({
      isAccessBlocked: false,
      blockedAt: null,
      workspaceName: null,
    }),
}));

/**
 * Selectors for optimized rendering
 */
export const workspaceAccessSelectors = {
  selectIsAccessBlocked: (state: WorkspaceAccessState) => state.isAccessBlocked,
  selectBlockedAt: (state: WorkspaceAccessState) => state.blockedAt,
  selectWorkspaceName: (state: WorkspaceAccessState) => state.workspaceName,
};
